import React, {Component, PropTypes} from 'react';
import { lang } from '../../strings';
import { format } from '../../utils/string';
import { trackEvent, TOPUP, LOAD } from '../../utils/analytics';

export default class DataPackageTopUpDialog extends Component {

   constructor(props) {
      super(props);
      this.state = this.makeInitialState(props);
   }

   makeInitialState(props) {
      return {
         selectedDataPackageId: null
      };
   }

   componentDidMount() {
      trackEvent(TOPUP, LOAD);
   }

   render() {
      let { topUps } = this.props;

      return (
         <div className="mp-popup-container">
            <div className="mp-popup-content">
               <a href="#" className="mp-close" onClick={this.closeForm}>&times;</a>
               <h2 className="h5 color-dark-blue">{lang.dataPackage.topUp.title}</h2>
               <form onSubmit={this.submitForm}>
                  <p>{lang.dataPackage.topUp.intro}</p>

                  <ul className="mp-list">
                     {topUps.map(dataPackage =>
                        <li key={dataPackage.id}>
                           <label>
                              <input type="radio" name="dataPackage" value={dataPackage.id} onChange={this.handleSelectedChange} /> {dataPackage.name}
                           </label>
                        </li>
                     )}
                  </ul>

                  <p className="mp-info">
                     {lang.dataPackage.topUp.important}
                  </p>
                  <input type="submit" className={this.setSubmitClass()} value={lang.dataPackage.topUp.title} />
               </form>
            </div>
         </div>
      );
   }

   setSubmitClass() {
      let { selectedDataPackageId } = this.state;
      return selectedDataPackageId ? 'mp-submit' : 'mp-disabled mp-submit';
   }


   handleSelectedChange = ev => {
      this.setState({selectedDataPackageId: ev.target.value});
   };

   closeForm = ev => {
      ev.preventDefault();
      this.props.onClose();
   };

   submitForm = ev => {
      ev.preventDefault();
      let { selectedDataPackageId } = this.state;
      let data = {
         selectedDataPackageId: selectedDataPackageId
      };

      this.props.onSubmit(data);
   };
}

DataPackageTopUpDialog.propTypes = {
   onClose: PropTypes.func.isRequired,
   onSubmit: PropTypes.func.isRequired,
   topUps: PropTypes.array.isRequired
};